<template>
  <div>
    <router-view></router-view>
    <BaseFormLoading :loading="loading"></BaseFormLoading>
  </div>
</template>
<script>

import BaseFormLoading from './base/BaseFormLoading'
import {authLogin} from '../security'
import {TypeSchedule, USER_NAME} from '../constant'

export default {
  name: 'Wrapper',
  components: {BaseFormLoading},
  data: function () {
    return {
      loading: false,
      intervalPing: null
    }
  },
  computed: {},
  created () {
  },
  mounted () {
    this.connectWebSocket();
    window.addEventListener("error", (event) => {
      window.location.href = window.location.href;
    })
  },
  methods: {
    connectWebSocket: function () {
      let that = this
      this.$connectSocket(successCallback => {
        if (successCallback) {

          /* Todo START get device information */
          successCallback.subscribe('/user/devices/info', tick => {
            let _data = JSON.parse(tick.body)
            if (_data.returnCode == 0) {
              /* Todo check device exits error */
              this.$router.push('/errors/404')
            } else if (_data.returnCode == 1) {
              authLogin(_data.data.authorities, _data.data.serialId, _data.data.deviceId)
              that.$sendMessageSocket('/app/devices/checkActive', this.$route.query['serialId'] || localStorage.getItem(USER_NAME), {})
            }
          })
          that.$sendMessageSocket('/app/devices/getInfo', this.$route.query['serialId'] || localStorage.getItem(USER_NAME), {})
          /* Todo END get device information */

          /* Todo START ping keep alive socket */
          successCallback.subscribe('/devices/ping', tick => {
          })
          if (this.intervalPing == null) {
            this.intervalPing = setInterval(() => {
              if (navigator.onLine && this.$checkConnectSocket() == true) {
                that.$sendMessageSocket('/app/devices/ping', this.$route.query['serialId'] || localStorage.getItem(USER_NAME), {})
              }
            }, 10000)
          }
          /* Todo END ping keep alive socket */

          /* Todo START check status device */
          successCallback.subscribe('/user/devices/checkStatus', tick => {
            let _data = JSON.parse(tick.body)
            if (_data.returnCode == 0) {
              /* Todo check device exits error */
              this.$router.push('/errors/404')
            } else {
              this.$sendMessageSocket('/app/devices/updateStatus', JSON.stringify({
                serialId: this.$route.query['serialId'] || localStorage.getItem(USER_NAME),
                status: 1
              }))
              if (_data.data.status == 0) {
                /* Todo write with status not accept */
                this.$router.push({
                  path: '/verify.html',
                }).catch(() => {
                })
              } else if (_data.data.status == 1) {
                this.$router.push({
                  path: '/player.html',
                }).catch(() => {
                })
                // that.$sendMessageSocket('/app/devices/getSchedule', this.$route.query['serialId'] || localStorage.getItem(USER_NAME), {})
              }
            }
          })
          /* Todo END check status device */

          /* Todo START delete device from cms and client disconnect socket */
          successCallback.subscribe('/user/devices/delete', tick => {
            let _data = JSON.parse(tick.body)
            if (_data.returnCode == 0) {
              /* Todo check device exits error */
              this.$router.push('/errors/404')
            } else if (_data.returnCode == 1) {
              that.$disConnectSocket()
            }
          })
          /* Todo END delete device from cms and client disconnect socket */

          /* Todo START get broadcast schedule */
          successCallback.subscribe('/user/devices/schedule', tick => {
            let _data = JSON.parse(tick.body)
            if (_data.returnCode == 0) {
              this.$router.push('/errors/404')
            } else if (_data.returnCode == 1) {
              if (_data.type === TypeSchedule.PLAY) {
                this.$store.commit('clearMessageSocket')
                this.$store.commit('getMessageSocket', _data.data)
                this.$router.push({
                  path: '/player.html',
                }).catch(() => {
                })
              } else {
                var messageSocket = this.$store.state.messageSocket
                if (messageSocket) {
                  var startTime = that.$helper.formatDate(messageSocket.startTime)
                  this.$sendMessageSaveHistoryWithStartTime(startTime)
                }
                this.$store.commit('clearMessageSocket')
                if (_data.type === TypeSchedule.CANCEL) {
                  this.$router.push({
                    path: '/default.html',
                  }).catch(() => {
                  })
                } else {
                  this.$router.push({
                    path: '/off.html',
                  }).catch(() => {
                  })
                }
              }
            }
          })
          that.$sendMessageSocket('/app/devices/getSchedule', this.$route.query['serialId'] || localStorage.getItem(USER_NAME), {})
          /* Todo END get broadcast schedule */

          /* Todo START get video default */
          successCallback.subscribe('/user/devices/default', tick => {
            let _data = JSON.parse(tick.body)
            if (_data.returnCode == 0) {
              this.$router.push('/errors/404')
            } else if (_data.returnCode == 1) {
              this.$store.commit('setVideoDefault', _data.data)
            }
          })
          /* Todo END get video default */
        }
      }, errorCallback => {
        that.$router.push('/errors/500')
        console.log(errorCallback)
      })
    },
  },
  watch: {},
  destroyed () {
    clearInterval(this.intervalPing);
  }
}
</script>

<style lang="scss" scoped>
@import "static/scss/wrapper";
</style>



// WEBPACK FOOTER //
// src/views/Wrapper.vue